<ng-container
  *ngIf="product"
  class="product-intro-component column fontclass"
>
  <div>
    <strong class="product-name">{{ product.name }}</strong>
    <div class="part-number">
      {{ "pdp.partNumber" | cxTranslate }}<strong> {{ product.code }}</strong>
    </div>
  </div>
    <div class="row col mx-auto">
      <div  *ngIf="product.newLegacyMaterial" class="text-warning legacy-text"><span class="material-icons">warning </span> {{ 'pdp.legacyMaterial' | cxTranslate : { partNo:
      product?.newLegacyMaterial } }}</div>
    </div>
  <a
    class="primary pointer product-name replacementLink"
    routerLink="{{ product.kitProductUrl }}"
    *ngIf="product.kitProductUrl"
    >{{ "pdp.ViewassociateKit" | cxTranslate }}</a
  >
  <div
    class="obsolete-product-div"
    *ngIf="product.obsoleteProductFlag && obsoleteProductMsg"
  >
    <div *ngIf="product.replacementProductUrl">
      <i class="material-icons">info</i
      ><strong> {{ "pdp.information" | cxTranslate }} </strong>
      <span class="obsolete-text"> {{ "pdp.obsoleteTxt" | cxTranslate }}</span
      ><i (click)="closeObsolete()" class="material-icons cancel">close</i>
    </div>
    <div *ngIf="!product.replacementProductUrl">
      <i class="material-icons">info</i
      ><strong> {{ "pdp.information" | cxTranslate }} </strong>
      <span class="obsolete-text">
        {{ "pdp.obsoleteNotAvailable" | cxTranslate }}</span
      ><i (click)="closeObsolete()" class="material-icons cancel-new">close</i>
    </div>
  </div>
  <div class="not-visible">{{ "pdp.hiddenDiv" | cxTranslate }}</div>
  <a
    *ngIf="product.replacementProductUrl"
    class="replacementLink"
    routerLink="{{ product.replacementProductUrl }}"
    >{{ "pdp.viewReplaceProduct" | cxTranslate }}</a
  >
  <div
    class="d-flex justify-content-between"
    *ngIf="
      (product.sellabilityFlag || product.quotabilityFlag) &&
      !product.obsoleteProductFlag
    "
  >
  
    <div class="col-6 price" *ngIf="loggedIn">
      <div>{{ "pdp.listPrice" | cxTranslate }}</div>
      <div class="row">
        <div
          *ngIf="product?.price?.value || product?.price?.value === 0"
          class="col-5 bold pd-0"
        >
          <!-- line-height: 16px;
/* identical to box height, or 133% */

letter-spacing: 0.25px; -->
          {{ product.price?.currencyIso }}
          {{
            product.price?.value * count
              | currency: product.price?.currencyIso:"symbol-narrow"
          }}
        </div>
        <div
          *ngIf="!product?.price?.value"
          class="truncate col-5 bold"
          matTooltipClass="vs-tooltip"
          matTooltipPosition="right"
          matTooltip='{{ "pdp.priceNotAvailable" | cxTranslate }}'
        >
        {{ "pdp.unavailable" | cxTranslate }}
        </div>
        <div class="col-6 quantity-show">
          ({{ "pdp.quantity" | cxTranslate }} {{ count }})
        </div>
      </div>
      <div
        class="not-visible"
        *ngIf="!product?.price?.value || product?.price?.value === 0"
      >
        {{ "pdp.hiddenDiv" | cxTranslate }}
      </div>
    </div>

    <div class="col-6 price" *ngIf="loggedIn">
      <div>{{ "pdp.yourPrice" | cxTranslate }}</div>
      <!-- <div class="bold" *ngIf="loggedIn && !product.price?.value">
        {{ product.netPrice?.currencyIso }}
          {{ product.netPrice?.value * count | currency: product.netPrice?.currencyIso:"symbol":"1.2-2" }}
         
      </div> -->
      <div class="row">
        <div
          *ngIf="product?.netPrice?.value || product?.netPrice?.value == 0"
          class="col-5 bold pd-0"
        >
          <!-- matTooltipClass="vs-tooltip"
          matTooltipPosition="right"
          matTooltip=" {{ product.netPrice?.currencyIso }}
          {{
              (product.netPrice?.value  *
                count) | currency: product.netPrice?.currencyIso:'symbol':'1.2-2'
            }}" -->
          {{ product.netPrice?.currencyIso }}
          {{
            product.netPrice?.value * count
              | currency: product.netPrice?.currencyIso:"symbol-narrow"
          }}
        </div>
        <div
          *ngIf="!product?.netPrice?.value"
          class="truncate col-5 bold"
          matTooltipClass="vs-tooltip"
          matTooltipPosition="right"
          matTooltip='{{ "pdp.priceNotAvailable" | cxTranslate }}'
        >
        {{ "pdp.unavailable" | cxTranslate }}
        </div>
        <!-- <div class="col-5 bold" *ngIf="product.price?.value != 0 || product.price?.value > 0">
          Unavailable
        </div> -->
        <div class="col-6 quantity-show">
          ({{ "pdp.quantity" | cxTranslate }} {{ count }})
        </div>
      </div>

      <div *ngIf="loggedIn" class="pointer ">
        <a  *ngIf = "product.expressAdderPriceData && product.expressAdderPriceData?.value > -1" class='material-icons' matTooltipClass="vs-tooltip" matTooltip='{{ "savedCart.expressDeliveryTooltipTxt" | cxTranslate}}' matTooltipPosition="above"
          (click)="this.openMenu = !this.openMenu"
          class="breakup-link link-color-eda"
        >
          {{ "pdp.viewBreakup" | cxTranslate }}
          <i *ngIf="!openMenu" class="material-icons open-icon">keyboard_arrow_down</i>
          <i *ngIf="openMenu" class="material-icons open-icon">keyboard_arrow_right</i>
        </a>
        <a  *ngIf = "!(product.expressAdderPriceData && product.expressAdderPriceData?.value > -1)"
          (click)="this.openMenu = !this.openMenu"
          class="breakup-link link-color"
        >
          {{ "pdp.viewBreakup" | cxTranslate }}
          <i *ngIf="!openMenu" class="material-icons open-icon">keyboard_arrow_down</i>
          <i *ngIf="openMenu" class="material-icons open-icon">keyboard_arrow_right</i>
        </a>
      </div>
      <div
        *ngIf="
          (product?.discountValues?.length == 0 ||
            !product?.discountValues ||
            !product.netPrice?.value) &&
          loggedIn
        "
        class="not-visible"
      >
      {{ "pdp.hidden" | cxTranslate }}
      </div>
      <div
        class="price-menu"
        *ngIf="openMenu"
        (clickOutside)="closeMenu($event)"
        [exclude]="'div,.primary'"
      >
        <!--LIST PRICE DIV-->
        <div class="row space">
          <div class="col-6">{{ "pdp.listPrice" | cxTranslate }}</div>
          <div
            class="col-6 right"
            matTooltipClass="vs-tooltip"
            matTooltipPosition="right"
            matTooltip="{{ product.price?.currencyIso }} {{
              product.price?.value * count
                | currency: product.price?.currencyIso:'symbol':'1.2-2'
            }}"
          >
            {{ product.price?.currencyIso }}
            {{
              product.price?.value * count
                | currency: product.price?.currencyIso:"symbol-narrow"
            }}
          </div>
        </div>
        <!--LIST PRICE DIV ends-->
        <!-- <div class="row space">
          <div class="col-6">{{ "pdp.discount" | cxTranslate }} 20%</div>
          <div
            class="col-6 right"
            matTooltipClass="vs-tooltip"
            matTooltipPosition="right"
            matTooltip=" {{ product.price?.currencyIso }} -{{
              product.price?.value * 0.2 * count  | currency: 'USD':'symbol':'1.2-2'
            }}"
          >
            {{ product.price?.currencyIso }} -{{
              product.price?.value * 0.2 * count
                | currency: "USD":"symbol":"1.2-2"
            }}
          </div>
        </div> -->
        <hr *ngIf="product?.discountValues?.length > 0" 
        class="horizontal-divider" />
        <div class="row space" *ngFor="let discount of product?.discountValues">
          <div class="col-6">{{ getDiscountName(discount.code) }}</div>
          <div class="col-2">{{ discount.appliedValue }}%</div>
          <div
            class="col-4 right"
            matTooltipClass="vs-tooltip"
            matTooltipPosition="right"
            matTooltip="{{ discount?.currency }} {{
              discount?.value * count
                | currency: discount?.currency:'symbol':'1.2-2'
            }}"
          >
            {{ discount?.currency }} -{{
              discount?.value * count
                | currency: discount?.currency:"symbol-narrow"
            }}
          </div>
        </div>
		 <div class="row space" *ngIf="product?.marketPremiumPriceData?.value > 0">
          <div class="col-6">{{ "pdp.aftermarketFactor" | cxTranslate }}</div>
          <div class="col-2">{{product?.afterMarketPremium}}%</div>
          <div class="col-4 right"
			matTooltipClass="vs-tooltip"
			matTooltipPosition="right"
			matTooltip=" {{ product?.marketPremiumPriceData?.currencyIso }} {{
			(product?.marketPremiumPriceData?.value ) * count
			| currency: product?.marketPremiumPriceData?.currencyIso:'symbol':'1.2-2'
			}}"
          >
          {{ product?.marketPremiumPriceData?.currencyIso }} {{
				(product?.marketPremiumPriceData?.value ) * count
			| currency: product?.marketPremiumPriceData?.currencyIso:'symbol-narrow'
			}}
		</div>

        </div>
         <div class="row space" *ngIf="product?.expressAdderPriceData?.value > 0">
          <div class="col-6">{{ "pdp.expressDeliveryAdder" | cxTranslate }}</div>
		  <div class="col-2">{{product?.expressAdderPercent}}%</div>
          <div
             class="col-4 right"
            matTooltipClass="vs-tooltip"
            matTooltipPosition="right"
            matTooltip=" {{ product?.expressAdderPriceData?.currencyIso }} {{
              (product?.expressAdderPriceData?.value ) * count
                | currency: product?.expressAdderPriceData?.currencyIso:'symbol':'1.2-2'
            }}"
          >
          {{ product?.expressAdderPriceData?.currencyIso }} {{
            (product?.expressAdderPriceData?.value ) * count
              | currency: product?.expressAdderPriceData?.currencyIso:'symbol-narrow'
          }}
          </div>
        </div> 
        <!--Tariff surchanrge div start-->
        <div class="row space" *ngIf="product?.tariffChargesPriceData?.value > 0">
          <div class="col-6">{{ "pdp.tariffSurcharge" | cxTranslate }}</div>
		  <div class="col-2">{{product?.tariffChargesPercent}}%</div>
          <div
             class="col-4 right"
            matTooltipClass="vs-tooltip"
            matTooltipPosition="right"
            matTooltip=" {{ product?.tariffChargesPriceData?.currencyIso }} {{
              (product?.tariffChargesPriceData?.value ) * count
                | currency: product?.tariffChargesPriceData?.currencyIso:'symbol':'1.2-2'
            }}"
          >
          {{ product?.tariffChargesPriceData?.currencyIso }} {{
            (product?.tariffChargesPriceData?.value ) * count
              | currency: product?.tariffChargesPriceData?.currencyIso:'symbol-narrow'
          }}
          </div>
        </div> 
      <!--Tariff surchanrge div end-->
        <hr
          *ngIf="product?.discountValues?.length > 0 || product?.expressAdderPriceData?.value!=0"
          class="horizontal-divider"
        />
        <div class="row space" *ngIf="product?.discountValues?.length > 0">
          <div class="col-6">{{ "pdp.totalAdjustment" | cxTranslate }}</div>
          <div
            class="col-6 right"
            matTooltipClass="vs-tooltip"
            matTooltipPosition="right"
            matTooltip='{{ product.price?.currencyIso }}
            - {{ 
              (product.price.value - product.netPrice.value)| currency: product.price?.currencyIso:"symbol-narrow" }}'
          >
            <!-- {{ product.price?.currencyIso }} -{{
              (product.price?.value * 0.2 + product.price?.value * 0.1) * count
                | currency: "USD":"symbol":"1.2-2"
            }} -->
            {{ product.price?.currencyIso }}
            -
              {{(product.price.value - product.netPrice.value)| currency: product.price?.currencyIso:"symbol-narrow" }}
            <!-- {{
              getTotalDiscounts(product?.discountValues,product?.expressAdderPriceData?.value)
                | currency: product.price?.currencyIso:"symbol-narrow":"1.2-2"
            }} -->
          </div>
        </div>

        <div class="row space">
          <div class="col-6">{{ "pdp.net" | cxTranslate }}</div>

          <!-- <div
          *ngIf="product.netPrice?.value>0"
          class="col-5 bold"
          matTooltipClass="vs-tooltip"
          matTooltipPosition="right"
          matTooltip="{{ product.netPrice?.currencyIso }}
        {{
            (product.netPrice?.value -
              (product.netPrice?.value * 0.2 + product.netPrice?.value * 0.1)) *
              count | currency: 'USD':'symbol':'1.2-2'
          }}"
        >
          {{ product.netPrice?.currencyIso }}
          {{
            (product.netPrice?.value -
              (product.netPrice?.value * 0.2 + product.netPrice?.value * 0.1)) *
              count | currency: "USD":"symbol":"1.2-2"
          }}
        </div> -->

          <div
            class="col-6 right"
            matTooltipClass="vs-tooltip"
            matTooltipPosition="right"
            matTooltip="{{ product.netPrice?.currencyIso }}
            {{
              product.netPrice?.value * count
                | currency: product.netPrice?.currencyIso:'symbol':'1.2-2'
            }}"
          >
            {{ product.netPrice?.currencyIso }}
            {{
              product.netPrice?.value * count
                | currency: product.netPrice?.currencyIso:"symbol-narrow"
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
  
</ng-container>
